export const LOGIN_INPUT_CHANGE = "LoginScreen/LOGIN_INPUT_CHANGE";
export const LOGIN_USER = "LoginScreen/LOGIN_USER";